module.exports = __webpack_public_path__ + "static/media/CTALogo.d3249ca6.png";